import { shorthands, makeStyles, mergeClasses } from "@griffel/react";
// eslint-disable-next-line no-restricted-imports

import { RibbonButtonState } from "./RibbonButton.types";
import {
  useCommonRibbonButtonStyles,
  getRibbonButtonSizedStyles,
} from "../../next/commonRibbonButtonStyles";

const useRootStyles = makeStyles({
  small: {
    ...shorthands.padding("1px"),
    minHeight: "24px",
    minWidth: "24px",
  },
  large: {
    height: "72px",
    paddingTop: "3px",
    paddingRight: "1px",
    paddingBottom: "1px",
    paddingLeft: "1px",
  },
});

export const useRibbonButtonStyles = (
  state: RibbonButtonState
): RibbonButtonState => {
  const rootStyles = useRootStyles();
  state.root.className = mergeClasses(
    getRibbonButtonSizedStyles(state.size, rootStyles),
    state.root.className
  );

  useCommonRibbonButtonStyles(state as RibbonButtonState);
  return state;
};
